import { Box, Card, Link, Tooltip } from '@mui/material';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { ReactElement } from 'react';
import { IntlShape } from 'react-intl';
import { inclusiveYellow } from 'shared/utils/inclusiveColors';

export const MultilineTooltip = ({
  message,
  children,
  footerLink,
  intl,
}: {
  message: string;
  children: ReactElement;
  footerLink?: string;
  intl: IntlShape;
}): ReactElement => {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: inclusiveYellow[50],
            '& .MuiTooltip-arrow': { color: 'white' },
          },
        },
      }}
      arrow
      sx={{
        fontSize: '14px',
        // border: 'none',
      }}
      title={
        <Card
          sx={{
            bgcolor: inclusiveYellow[50],
            // color: 'white',
            boxShadow: 'none',
          }}
        >
          <Box sx={{ whiteSpace: 'pre-line', p: 1 }}>{message}</Box>
          {footerLink && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Link
                href={footerLink}
                target='_blank'
                rel='noopener noreferrer'
                sx={{
                  cursor: 'pointer !important',
                  textDecoration: 'underline !important',
                  color: 'blue !important',
                  '&:hover': { color: 'black !important' },
                }}
              >
                {formatTranslation(intl, CommonTranslationKeys.readMore)}
              </Link>
            </Box>
          )}
        </Card>
      }
    >
      {children}
    </Tooltip>
  );
};
